import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  file: null,
  loading: false,
  error: null,
  successMessage: null,
};

const assessmentUploadSlice = createSlice({
  name: 'uploadAssessment',
  initialState,
  reducers: {
    uploadFileStart: (state) => {
      state.loading = true;
      state.error = null;
      state.successMessage = null;
    },
    uploadFileSuccess: (state, action) => {
      state.loading = false;
      state.fileUrl = action.payload.url;  // Assuming the response contains the file URL
      state.successMessage = 'File uploaded successfully!';
    },
    uploadFileFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.successMessage = null;
    },
    loadingTrue: (state) => {
      state.loading = true;
    },
    loadingFalse: (state) => {
      state.loading = false;
    },
  },
});

export const { uploadFileStart, uploadFileSuccess, uploadFileFailure, loadingTrue, loadingFalse } = assessmentUploadSlice.actions;

export default assessmentUploadSlice.reducer;
